import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RmvdDatePipeModule } from '../../pipes/rmvdDate.pipe';
import { ActionMenuComponentModule } from '../action-menu/action-menu.component.module';
import { DataObjectIconComponentModule } from '../dataobject-icon/dataobject-icon.component';
import { ValuationRunPreviewComponent } from './valuation-run-preview.component';

@NgModule({
  declarations: [ValuationRunPreviewComponent],
  exports: [ValuationRunPreviewComponent],
  imports: [
    CommonModule,
    ActionMenuComponentModule,
    DataObjectIconComponentModule,
    RmvdDatePipeModule,
  ],
})
export class ValuationRunPreviewComponentModule {}
